module.exports = __webpack_public_path__ + "img/game-bg.96ab5a13.png";